export default __webpack_public_path__ + "static/media/Joyce Anderson.07fbaa3b.mp3";